import { Router } from "@uuip/unified-ui-platform";
import { BaseView } from "../_base-view/BaseView";
import AgentPerformanceBlock from "./blocks/AgentPerformanceBlock";
import styles from "./agent-performance-view.scss";
const AgentPerformanceView = () => {
    return new Router.RouterView.BlocksMap(BaseView({ taskArea: false }), {
        blocks: {
            agentPerformance: AgentPerformanceBlock()
        },
        styles
    });
};
export default AgentPerformanceView;
